template = require('./profile_personal.html.slim')
#
angular.module('wbComponents').directive 'profilePersonal', ->
  restrict: 'E'
  templateUrl: template
  controller: ['$scope', ($scope) -> {}]
  controllerAs: 'ctrl'
  bindToController: true
  replace: true
  scope:
    clientProfile: '=',
    disableTwoFactor: '&',
  link: ($scope, $el, $attrs) ->
    $scope.showSin = true if $attrs.sin is 'true'
    $scope.show2fa = !$attrs.hide2fa
